splitTips.$inject = ['$uibModal']
export default function splitTips($uibModal) {
  return function (code) {
    const config = {
      hasTax: {
        text: [
          '当同一销售单按指定金额，或按总金额平均拆分多张发票时，按含税金额还是不含税金额进行计算。',
          '• 按不含税拆：拆分发票汇总金额；',
          '• 按含税拆：拆分发票价税合计金额；',
          '1）金税盘票种限额仅支持按不含税金额计算；',
          '2）若需要按含税金额拆分，请自行先按税率计算好，保证不含税金额不超过金税盘票种的限额。'
        ],
        example: '税盘票种限额1000，税率0.01~0.17，则含税金额设置范围 1010~1170，建议按照企业可开税率的最低值设置。'
      },
      sameGoods: {
        text: [
          '合并后商品行数量累加，单价=总金额/总数量，可设置单价保留小数位。若合并后有金额误差，则系统会自动调整',
          '负数行≠折扣行，负数行在票面上不显示。'
        ],
        example: {
          th: ['行性质', '商品名称', '数量', '单价', '金额', '其他条件'],
          list: [
            ['普通商品行', 'A', 10, 5, 50, ''],
            ['普通商品行', 'B', 10, 5, 50, ''],
            ['负数行', 'A', -2, 5, -10, ''],
            ['负数行', 'B', -2, 8, -16, ''],
            ['合并后:', ' ', ' ', ' ', ' ', ' '],
            ['普通商品行', 'A', 8, 5, 40, '单价一致合并'],
            ['普通商品行', 'B', 8, 4.25, 34, '单价不一致合并']
          ]
        }
      },
      sameName: {
        text: [
          ' 当有负数行商品时，找其他正数商品进行金额冲抵（优先商品名称一致的冲抵），忽略负数行数量跟单价。若勾选“与正数商品行名称、税率、规格型号、计量单位、单价一致时优先合并”，则按商品行合并规则处理，数量累加。',
          '1）反算数量，数量=冲抵后金额/正数行单价，数量保留小数位设置有效',
          '2）反算单价，单价=冲抵后金额/正数行数量，单价保留小数位设置有效'
        ],
        example: {
          th: ['行性质', '商品名称', '数量', '单价', '金额', '其他条件'],
          list: [
            ['普通商品行', 'A', 10, 5, 50, ''],
            ['负数行', 'A', -12, 1, -12, ''],
            ['普通商品行', 'B', 10, 8, 80, ''],
            ['普通商品行', 'C', 10, 2, 20, ''],
            ['负数行', 'C1', -5, 10, -50, ''],
            ['合并后:反算数量，单价不变', '', ' ', ' ', ' ', ' '],
            ['普通商品行', 'A', 9.6, 5, 48, ''],
            ['普通商品行', 'B', 6.25, 8, 50, ''],
            ['合并后:反算单价，数量不变', '', ' ', ' ', ' ', ' '],
            ['普通商品行', 'A', 10, 4.8, 48, ''],
            ['普通商品行', 'B', 10, 5, 50, ''],
            // ['负数行冲抵规则，只冲抵金额，负数行数量、单价忽略', '', ' ', ' ', ' ', ' ']
          ]
        }
      },
      splitForNum: {
        text: [
          ' 同一单据因超限被拆分多张，且加上发票最后一行商品金额正好超限额，此时是否需要将最后一行商品行按数量拆分到多张发票中。',
          '为满足商品单价、数量指定小数位，被拆分商品在最后一张发票上可能会出现：金额!=数量*单价，为保证被拆分商品的总金额恒等，系统将调整被拆分商品的数量、单价、金额，不同设置将影响最后一张发票中单价、数量的计算取值规则：',
          '1）调整金额：最后一张拆分数量=商品总数量-前面被拆分数量之和，单价不变，系统将把金额误差分摊到前面被拆分行，数量保留小数位设置有效；',
          '2）调整数量：最后一张拆分数量=剩余金额/单价，可能最终总数量不等，数量保留小数位设置有效；',
          '3）调整单价：最后一张单价=剩余金额/剩余数量，可能最后一张发票上商品单价不一致，单价保留小数位设置有效；'
        ],
        example: {
          th:['单据','商品名称','数量','单价','金额','','其他说明'],
          list:[
            ['单据1','商品A','10','8','80.01','',''],
            ['单据2','商品A','10','8','80.01','',''],
            ['合并拆分后：设置调整金额误差，单价不变，总数量不变','','','','','',''],
            ['发票','商品A','拆分数量','单价','计算金额','票面金额','说明'],
            ['发票1','商品A','12.5','8','100','100.01',''],
            ['发票2','商品A','7.5','8','60','60.01',''],
            ['合并后拆分：设置调整数量，单价不变','','','','','',''],
            ['发票1','商品A','12.5','8','100','100',''],
            ['发票2','商品A','7.5025','8','60','60.02',''],
            ['合并后拆分：设置调整单价，数量不变','','','','',''],
            ['发票1','商品A','12.5','8','100','100',''],
            ['发票2','商品A','7.5','8.0027','60','60.02',''],
          ]
        }
      },
      totalTaxAmt: {
        text: [
          '误差=不含税金额*税率-税额，政策允许的税额误差范围内，单行±0.06，整张发票±1.27。',
          '商品行/单据合并后，发票总税额汇总计算时，可能出现误差，系统将根据设置的取值标准，将误差分摊到其他明细行的税额或被拆分的其他发票中，以保证误差在允许范围内：',
          '发票总税额=明细行税额之和，明细行税额计算方式：',
          '1）以系统计算为准，则系统自动计算明细行税额，税额=不含税金额*税率。当出现误差时，将误差分摊到其他明细行或发票，可能每行明细的税额不等于不含税金额*税率',
          '2）以实际输入税额为准，则明细行税额以自己输入的税额为准，可能出现总不含税金额*税率不等于明细行税额之和的情况',
          '3）当整张发票税额误差大于±1.27时，可以选择拆分另外一张发票，如不勾选，则系统会提示错误，可自行修改明细行金额税额后再传入'
        ],
        example: {
          th: ['商品序号', '含税金额', '税率', '税额', '说明'],
          list: [
            [1, 1000, 0.06, 56.6, ''],
            [2, 1000, 0.06, 56.6, ''],
            [3, 1000, 0.06, 56.6, ''],
            [4, 1000, 0.06, 56.6, ''],
            [5, 1000, 0.06, 56.6, ''],
            [6, 100, 0.06, 5.66, ''],
            [7, 100, 0.06, 5.66, ''],
            [8, 100, 0.06, 5.66, ''],
            [9, 150, 0.06, 8.49, ''],
            ['汇总1~8行', 5300, 0.06, 299.98, ''],
            ['1.合并开票，以实际传入税额为准', '', '', '', ''],
            ['1~8', 5300, 0.06, 299.98, '假设明细行开票之前已算好税额传入开票系统'],
            [9, 150, 0.06, 8.49, ''],
            ['开票汇总', 5450, 0.06, 308.47, ''],
            ['2.合并开票，由系统计算', '', '', '', ''],
            ['1~8', 5300, 0.06, 299.98, '假设未传明细行税额，系统自动计算总税额'],
            [9, 150, 0.06, 8.49, ''],
            ['开票汇总', 5450, 0.06, 308.49, ''],
          ]
        }
      },
      splitAmount:{
        text:[
          '当一张销售单需要拆分多张发票开具时，发票票面限额的拆分方式。',
          '注意：',
          '受商品行不同规则设置的影响，这里的满额、平均是相对概念，不会绝对的满额、平均开具发票。',
          '平均拆分时规则配置建议：',
          '1）保留小数位，数量、单价不要取整；',
          '2）商品行拆分规则，选择按数量拆分；',
          '3）商品行设置由系统进行排序；',
        ]
      }
    }


    $uibModal.open({
      template: getDialogTemplate(),
      backdrop: 'static',
      controller: ['$scope', 'config', '$uibModalInstance', modalCtrl],
      openedClass: 'mod-modal mod-modal-lg mod-modal-big',
      resolve: {
        config() {
          return {
            config: config[code],
            code
          }
        }
      },
    }).result.then((data) => {
      // 点击确定才更新自定义配置
      save(data.config)
    })
  }
}

function getDialogTemplate() {
  return `
    <div class="page-settablesyllable">
    <div class="modal-header clearfix">
      <h3 class="modal-title">说明</h3>
      <div class="modal-cancel close" ng-click="cancel()"><i class="icon iconfont icon-shanchu3"></i></div>
    </div>
    <div class="modal-body form-horizontal clearfix">
      <div ng-repeat="t in text track by $index">{{t}}</div>
      <div style="margin-top:10px;">举例:</div>
      <div ng-if="noTable" class="et-section-space">{{example}}</div>
      <div class="mod-table" ng-if="!noTable">
        <table class="table" id="table-{{code}}">
          <thead>
            <tr>
              <th ng-repeat="t in example.th">{{t}}</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="r in example.list track by $index">
              <td ng-repeat="t in r track by $index"><div title="{{t}}" style="word-wrap:break-word;">{{t}}</div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
    `
}

function modalCtrl($scope, config, $uibModalInstance) {
  $scope.text = config.config.text
  $scope.example = config.config.example
  $scope.noTable = typeof ($scope.example) == 'string'
  $scope.code = config.code
  // 关闭
  $scope.cancel = function cancel() {
    $uibModalInstance.dismiss('cancel')
  }
  setTimeout(() => {
    if ($scope.code == 'sameName') {
      $('#table-sameName tr:nth-child(7) td:nth-child(6)').attr('rowSpan', 2).find('div').html('商品C名称相同，<br>规格型号等不相同，<br>优先冲抵商品C')
      $('#table-sameName tr:nth-child(10) td:nth-child(6)').attr('rowSpan', 2).find('div').html('商品C因金额全被冲抵，<br>票面不显示，<br>直接改变商品B的数量、单价')
      $('#table-sameName tr:nth-child(12) td:nth-child(1)').attr('colSpan', 6).css('text-align', 'center')
      $('.modal-body.form-horizontal.clearfix>.mod-table').prepend('<div>负数行冲抵规则，只冲抵金额，负数行数量、单价忽略</div>')
    }
    if ($scope.code == 'totalTaxAmt') {
      $('#table-totalTaxAmt tr:nth-child(16) td:nth-child(5)').attr('rowSpan', 3).find('div').css('width', '240px')
      $('#table-totalTaxAmt tr:nth-child(12) td:nth-child(5)').attr('rowSpan', 3).find('div').css('width', '240px')
      $('#table-totalTaxAmt tr:nth-child(11) td:nth-child(1)').attr('colSpan', 5)
      $('#table-totalTaxAmt tr:nth-child(15) td:nth-child(1)').attr('colSpan', 5)
    }
    if($scope.code == 'splitAmount') {
      $('.modal-body.form-horizontal.clearfix>div:nth-child(4)').addClass('require').css("margin-top","10px")
      $('.modal-body.form-horizontal.clearfix').append('<div>销售单金额21W，票面限额设置10W，在不考虑单价、数量小数位等其他条件的理想状态下：</div>')
      .append('<div>1）按满额拆，将拆成10W、10W、1W三张发票；</div>')
      .append('<div>2）平均拆分，将拆成7W、7W、7W三张发票；</div>')
    }
    if($scope.code=='splitForNum'){
      $('#table-splitForNum tr:nth-child(3) td:nth-child(1)').attr('colSpan', 7)
      $('#table-splitForNum tr:nth-child(7) td:nth-child(1)').attr('colSpan', 7)
      $('#table-splitForNum tr:nth-child(10) td:nth-child(1)').attr('colSpan', 7)
      $('#table-splitForNum th:nth-child(7)').attr('colSpan', 2)
      $('#table-splitForNum tr:nth-child(1) td:nth-child(7)').attr('colSpan', 2).attr('rowSpan',2).html('1，这里为更好的反应数据变化，<br>假设传入的金额因为做账等原因有0.01分钱的误差；<br>（1分钱金额误差政策是允许开票的）<br>2，系统在误差范围内，强制保证传入单据的价税合计相等；')
      $('#table-splitForNum tr:nth-child(2) td:nth-child(7)').attr('colSpan', 2)
      $('#table-splitForNum tr:nth-child(5) td:nth-child(7)').attr('rowSpan',2).html('1，最后一张发票数量=20-12.5=7.5<br>2，金额：剩余金额=（80.01+80.01）-100=60.02，<br>数量*单价=60，有2分钱误差<br>3，数量、单价不变，金额误差调整到其他行，最后结果:<br>发票2金额为60.01，还有一分钱误差调整到发票1上，金额为100.01')
      $('#table-splitForNum tr:nth-child(8) td:nth-child(7)').attr('rowSpan',2).html('最后一张发票数量=（160.02-100）/8=7.5025')
      $('#table-splitForNum tr:nth-child(11) td:nth-child(7)').attr('rowSpan',2).html('最后一张发票单价=（160.02-100）/（20-12.5）≈8.0027')
    }
  })
}


// WEBPACK FOOTER //
// ./src/common/services/splitTips.js